module.exports = __webpack_public_path__ + "assets/GoldTheta.7bb2d1ec8503f53d4cee96a49c201ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldTheta.png
// module id = 776
// module chunks = 0